import { Box, Chip, Typography } from '@mui/material';

import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function StatusPanel({ body, chipLabel, title }) {
  if (!body && !chipLabel) return null;

  return (
    <Box sx={runSummaryAgentReportStyles.reportPanel}>
      <Box sx={runSummaryAgentReportStyles.panelTitleRow}>
        <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitleNoMargin}>
          {title}
        </Typography>
        {chipLabel && (
          <Chip size="small" label={chipLabel} sx={runSummaryAgentReportStyles.statusChip} />
        )}
      </Box>
      {body && (
        <Typography variant="body2" color="text.secondary">
          {body}
        </Typography>
      )}
    </Box>
  );
}
